import { clsx } from 'clsx';

import { ROUTES } from '@shared/constants/routes';
import { CustomLink } from '@shared/ui/CustomLink';

import { Dropdown } from './Dropdown/Dropdown';
import cls from './Links.module.scss';

type LinksProps = {
  className?: string;
};

export const Links = ({ className }: LinksProps) => {
  return (
    <nav className={clsx(cls.wrap, className)}>
      <CustomLink
        aria-label={'Перейти на страницу Вопрос-ответ'}
        href={ROUTES.QUESTION_ANSWER}
        className={cls.link}
      >
        Вопрос-ответ
      </CustomLink>
      <CustomLink
        aria-label={'Перейти на страницу О компании'}
        href={ROUTES.ABOUT_COMPANY}
        className={cls.link}
      >
        О компании
      </CustomLink>

      <CustomLink
        aria-label={'Перейти на страницу Контакты'}
        href={ROUTES.CONTACTS}
        className={cls.link}
      >
        Контакты
      </CustomLink>

      <CustomLink
        aria-label={'Перейти на страницу Эксплуатация'}
        href={ROUTES.EXPLOITATION}
        className={clsx(cls.link, cls.mobile)}
      >
        Эксплуатация
      </CustomLink>

      <CustomLink
        aria-label={'Перейти на страницу Гарантия'}
        href={ROUTES.WARRANTY}
        className={clsx(cls.link, cls.mobile)}
      >
        Гарантия
      </CustomLink>

      <CustomLink
        aria-label={'Перейти на страницу Доставка и оплата'}
        href={ROUTES.DELIVERY_AND_PAYMENT}
        className={clsx(cls.link, cls.mobile)}
      >
        Доставка и оплата
      </CustomLink>

      <CustomLink
        aria-label={'Перейти на страницу Полезные статьи'}
        href={ROUTES.BLOG}
        className={clsx(cls.link, cls.mobile)}
      >
        Полезные статьи
      </CustomLink>
      <Dropdown />
    </nav>
  );
};
